import { PLANNED_MAINTENANCE_TEMPLATES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/planned_maintenance_templates_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'plannedMaintenanceTemplatesIndex',
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_PLANNED_MAINTENANCE_TEMPLATES_AUTOCOMPLETE',
	'plannedMaintenanceAdvancedFilters',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
